import { useNavigate } from "react-router-dom";

export const useOnErrorNavigation = () => {
  const navigate = useNavigate();

  const handleErrorNavigation = (status?: number) => {
    if (status === 404) navigate("/404");
  };
  return { handleErrorNavigation };
};
